export default {
    pattern: {
        value: /[A-Z\d]{6,}/,
        message: 'Wpisz poprawny numer rejestracyjny'
    }
}